import { createAsyncThunk } from '@reduxjs/toolkit';
import { addLoading, removeLoading } from '../appAction';
import { Enums, Paths, Value } from '@utils/constants';
import { axios } from '@utils/lib';

export const getApplicationListAsync = createAsyncThunk(
  'api/getApplicationListAsync',
  async (query: IApplicationListQuery, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const searchQuery: Record<string, string> = {
      'pagination[page]': query.page ?? Value.TABLE_PAGE_INIT,
      'pagination[pageSize]': query.pageSize ?? Value.TABLE_PAGE_SIZE,
      populate: 'ssid',
      sort: 'id:desc',
    };
    if (query.disabled) searchQuery['filters[disabled][$eq]'] = query.disabled;
    if (query.applicationName)
      searchQuery['filters[name][$contains]'] = query.applicationName;

    const params = new URLSearchParams(searchQuery).toString();

    try {
      const { data } = await axios.request<IListRes<IApplicationDetailData>>(
        Enums.HTTP_METHOD.GET,
        Paths.APPLICATION_LIST + '?' + params,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const getApplicationDetailAsync = createAsyncThunk(
  'api/getApplicationDetailAsync',
  async (id: number, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IDataRes<IApplicationDetailData>>(
        Enums.HTTP_METHOD.GET,
        Paths.APPLICATION_LIST + '/' + id,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);
